import { FC, useState } from 'react'
import { Modal, Form, Select, Button, notification, Upload, Spin } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

import { useFileTypes, useRailcarFiles } from '@hooks'
import { Railcar } from '@types'

interface AddRailCarFileModalProps {
  visible: boolean
  onCancel: () => void
  onCreate: (values: any) => void
  railCar: Railcar
}

const AddRailCarFileModal: FC<AddRailCarFileModalProps> = ({
  visible,
  onCancel,
  onCreate,
  railCar,
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const [selectedFileTypeId, setSelectedFileTypeId] = useState<number | undefined>()

  const [fileList, setFileList] = useState<any[]>([])
  const { uploadRailcarFileIsFetching, uploadRailcarFile } = useRailcarFiles()
  const { railCarFileTypes } = useFileTypes()

  const handleFileTypeChange = (fileTypeId: number | undefined) => {
    setSelectedFileTypeId(fileTypeId)
    form.setFieldsValue({ fileTypeId })
  }

  const handleUploadChange = (info: any) => {
    let newFileList = [...info.fileList]

    newFileList = newFileList.slice(-1)

    setFileList(newFileList)
  }

  const handleCreateFile = async () => {
    try {
      if (fileList.length > 0) {
        const filePayload = {
          railcarId: railCar.id,
          railcarFile: fileList[0].originFileObj,
          fileTypeId: selectedFileTypeId,
        }

        uploadRailcarFile(filePayload, {
          onSuccess: newFile => {
            onCreate(newFile) // Pasa el nuevo archivo al padre
            resetForm()
          },
        })
      } else {
        notification.error({
          message: t('globals.file_required'),
        })
      }
    } catch (error) {
      notification.error({
        message: t('globals.error_uploading_file'),
      })
    }
  }
  const resetForm = () => {
    form.resetFields()
    setFileList([])
  }

  const handleCancel = () => {
    resetForm()
    onCancel()
  }

  return (
    <Modal
      title={t('new_file')}
      open={visible}
      onCancel={handleCancel}
      cancelText={t('cancel')}
      className="entity-modal"
      okText={t('save')}
      onOk={handleCreateFile}
      okButtonProps={{ disabled: !!uploadRailcarFileIsFetching }}
    >
      <Form form={form} layout="horizontal">
        <Spin spinning={!!uploadRailcarFileIsFetching}>
          <Form.Item
            label={t('file_type')}
            name="fileTypeId"
            style={{ marginBottom: '6px' }}
            rules={[{ required: true, message: t('please_input_PO_number') }]}
          >
            <Select
              onChange={handleFileTypeChange}
              options={railCarFileTypes?.map(fileType => ({
                label: fileType.name,
                value: fileType.id,
              }))}
            />
          </Form.Item>
          <Form.Item
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginBottom: '0.5rem',
            }}
          >
            <Upload onChange={handleUploadChange} fileList={fileList} beforeUpload={() => false}>
              <Button
                icon={<UploadOutlined />}
                style={{ margin: '0.5rem', justifyContent: 'center', width: '10rem' }}
              >
                {t('upload_file')}
              </Button>
            </Upload>
          </Form.Item>
          <div className="message-modal-file">{t('message_document')}</div>
        </Spin>
      </Form>
    </Modal>
  )
}

export default AddRailCarFileModal
